import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import PageTransition from "./components/PageTransition";
import Reserver from "./pages/Reserver";
import VeloDetail from "./pages/VeloDetail";
import Professionnels from "./pages/ProfessionnelsComplete";
import NosServices from "./pages/NosServices";
import FAQ from "./pages/FAQ";
import Collectivites from "./pages/Collectivites";
import BorneAutoreparation from "./pages/BorneAutoreparation";
import QuiSommesNousRework from "./pages/QuiSommesNousRework";
import AchatParcsVelo from "./pages/AchatParcsVelo";
import EspacePartenaires from "./pages/EspacePartenaires";
import NousContacter from "./pages/NousContacter";
import ChoisirCamping from "./pages/ChoisirCamping";
import ChoisirVelo from "./pages/ChoisirVelo";
import Tarifs from "./pages/Tarifs";
import DemandeLivraison from "./pages/DemandeLivraison";
import DemandeSaisonnier from "./pages/DemandeSaisonnier";
import DemandeGroupe from "./pages/DemandeGroupe";
import Balades from "./pages/Balades";
import MentionsLegales from "./pages/MentionsLegales";

import AdminPortal from "./pages/AdminPortal";
import AdminDashboard from "./pages/AdminDashboard";
import AdminMessages from "./pages/AdminMessages";
import AdminLayout from "./components/AdminLayout";

import VelosReconditionnésRedesign from "./pages/VelosReconditionnésRedesign";
import Gateway from "./pages/Gateway";
import Particuliers from "./pages/Particuliers";
import NotFound from "./pages/NotFound";

// Destinations
import IleDeRe from "./pages/destinations/IleDeRe";
import Vendee from "./pages/destinations/Vendee";
import Royan from "./pages/destinations/Royan";
import Soulac from "./pages/destinations/Soulac";
import Montalivet from "./pages/destinations/Montalivet";
import LesLandes from "./pages/destinations/LesLandes";

// Villages Île de Ré
import RivedouxPlage from "./pages/destinations/ile-de-re/RivedouxPlage";
import SaintMartinDeRe from "./pages/destinations/ile-de-re/SaintMartinDeRe";
import ArsEnRe from "./pages/destinations/ile-de-re/ArsEnRe";

// Types de vélos
import VelosElectriques from "./pages/VelosElectriques";
import VelosClassiques from "./pages/VelosClassiques";
import VelosEnfants from "./pages/VelosEnfants";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <ScrollToTop />
        <PageTransition>
          <Routes>
          <Route path="/" element={<Gateway />} />
          <Route path="/particuliers" element={<Particuliers />} />
          <Route path="/reserver" element={<Reserver />} />
          <Route path="/velos-occasion" element={<VelosReconditionnésRedesign />} />
          <Route path="/velos-occasion/:id" element={<VeloDetail />} />
          <Route path="/professionnels" element={<Professionnels />} />
          <Route path="/nos-services" element={<NosServices />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/collectivites" element={<Collectivites />} />
          <Route path="/borne-autoreparation" element={<BorneAutoreparation />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNousRework />} />
          <Route path="/achat-parcs-velo" element={<AchatParcsVelo />} />
          <Route path="/espace-partenaires" element={<EspacePartenaires />} />
          <Route path="/nous-contacter" element={<NousContacter />} />
          <Route path="/choisir-camping" element={<ChoisirCamping />} />
          <Route path="/choisir-velo" element={<ChoisirVelo />} />
          <Route path="/demande-livraison" element={<DemandeLivraison />} />
          <Route path="/demande-saisonnier" element={<DemandeSaisonnier />} />
          <Route path="/demande-groupe" element={<DemandeGroupe />} />
          <Route path="/balades" element={<Balades />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          
          {/* TYPES DE VÉLOS */}
          <Route path="/velos-electriques" element={<VelosElectriques />} />
          <Route path="/velos-classiques" element={<VelosClassiques />} />
          <Route path="/velos-enfants" element={<VelosEnfants />} />
          
          {/* DESTINATIONS */}
          <Route path="/destinations/ile-de-re" element={<IleDeRe />} />
          <Route path="/destinations/vendee" element={<Vendee />} />
          <Route path="/destinations/royan" element={<Royan />} />
          <Route path="/destinations/soulac" element={<Soulac />} />
          <Route path="/destinations/montalivet" element={<Montalivet />} />
          <Route path="/destinations/les-landes" element={<LesLandes />} />
          
          {/* VILLAGES Île DE RÉ */}
          <Route path="/destinations/ile-de-re/rivedoux-plage" element={<RivedouxPlage />} />
          <Route path="/destinations/ile-de-re/saint-martin-de-re" element={<SaintMartinDeRe />} />
          <Route path="/destinations/ile-de-re/ars-en-re" element={<ArsEnRe />} />
          
          {/* ADMIN PORTAL 2.0 ROUTES */}
          <Route path="/admin" element={<AdminPortal />} />
          <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
          <Route path="/admin/messages" element={<AdminLayout><AdminMessages /></AdminLayout>} />
          <Route path="/admin/reservations" element={<AdminLayout><div className="p-8 text-center"><h2 className="text-2xl font-bold mb-4">Suivi Réservations</h2><p className="text-gray-600">Module en développement</p></div></AdminLayout>} />
          <Route path="/admin/equipe" element={<AdminLayout><div className="p-8 text-center"><h2 className="text-2xl font-bold mb-4">Espace Équipe Admin</h2><p className="text-gray-600">Module en développement</p></div></AdminLayout>} />
          <Route path="/admin/partenaires" element={<AdminLayout><div className="p-8 text-center"><h2 className="text-2xl font-bold mb-4">Espace Partenaires Admin</h2><p className="text-gray-600">Module en développement</p></div></AdminLayout>} />
          <Route path="/admin/technique" element={<AdminLayout><div className="p-8 text-center"><h2 className="text-2xl font-bold mb-4">Technique & Maintenance</h2><p className="text-gray-600">Module en développement</p></div></AdminLayout>} />
          <Route path="/admin/statistiques" element={<AdminLayout><div className="p-8 text-center"><h2 className="text-2xl font-bold mb-4">Statistiques</h2><p className="text-gray-600">Module en développement</p></div></AdminLayout>} />
          <Route path="/admin/parametres" element={<AdminLayout><div className="p-8 text-center"><h2 className="text-2xl font-bold mb-4">Paramètres</h2><p className="text-gray-600">Module en développement</p></div></AdminLayout>} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
          </Routes>
        </PageTransition>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
